import React from "react";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { RecoilRoot } from "recoil";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import FormUISchemaResolver from "../../../data/schema/profiles/resolver";
import HelpfulTipsUIResolver from "./HelpfulTipModals/resolver";
import ModalBox from "../../Form/components/ModalBox";
import "./style.scss";

class NewEntityModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  saveEntity = (values) => {
    this.props.handleSubmit(values);
  };

  render() {
    const {
      buttonName,
      buttonStyle,
      navigateButton,
      formName,
      buttonType,
      menuItemStyle,
      counties,
      groupId,
    } = this.props;

    const closeButton = {
      position: "absolute",
      right: "20px",
      top: "20px",
      background: "none",
      border: "none",
      padding: 0,
    };

    const closeButtonIcon = {
      height: "40px",
      width: "40px",
    };

    const closeButtonText = {
      position: "absolute",
      // right: "27px",
      // top: "60px",
      right: "8px",
      top: "40px",
      height: "40px",
      width: "35px",
      fontSize: "13px",
    };

    const linkStyle = {
      cursor: "pointer",
    };

    let resolvedUISchema = FormUISchemaResolver(formName);
    const modalUI = HelpfulTipsUIResolver(formName);

    const formStyles = {
      flexBasis: "50%",
    };
    return (
      <div
        className="grid-row"
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "0.5rem",
        }}
      >
        {buttonType === "link" && (
          <a onClick={this.openModal} style={linkStyle} className={`usa-link`}>
            <span>{buttonName}</span>
          </a>
        )}

        {buttonType === "button" && (
          <button
            style={{ margin: "0 0 15px 0" }}
            onClick={this.openModal}
            className={`usa-button ${
              buttonStyle === "outline" && "usa-button--outline"
            } usa-button--big add-button`}
          >
            <span>{buttonName}</span>
          </button>
        )}

        {!!navigateButton && (
          <Link
            className="usa-button usa-button--outline"
            style={{ margin: "0 0 15px 0" }}
            to={navigateButton.nav}
          >
            {navigateButton.name}
          </Link>
        )}

        {buttonType === "popupAction" && (
          <div
            style={menuItemStyle}
            className="menu-item dropdown-label-View"
            onClick={this.openModal}
          >
            <span>Edit</span>
          </div>
        )}

        <Modal
          className="modal-style"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          overlayClassName="Overlay"
        >
          <button style={closeButton} onClick={this.closeModal} type="button">
            <MdClose style={closeButtonIcon} />
            <span style={closeButtonText}>CLOSE</span>
          </button>
          <div className="grid-row profile-modal-content">
            <RecoilRoot>
              <SimpleForm
                formStyles={formStyles}
                handleSave={this.saveEntity}
                uiSchema={resolvedUISchema}
                inputResolver={inputResolver}
                counties={counties}
                closeModal={this.closeModal}
                groupId={groupId}
              />
            </RecoilRoot>

            <ModalBox className="helpful-tips-box" {...modalUI} />
          </div>
        </Modal>
      </div>
    );
  }
}

export default NewEntityModal;
